import React from 'react';
import { SwitchLabel, SwitchSlider, SwitchWrapper } from './styles';

export interface SwitchProps {
  checked?: boolean;
  onChangeValue?: (value: boolean) => void;
}

const Switch = ({ checked = false, onChangeValue }: SwitchProps) => {
  return (
    <SwitchWrapper>
      <SwitchLabel>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => {
            if (onChangeValue) onChangeValue(e.target.checked);
          }}
        />
        <SwitchSlider />
      </SwitchLabel>
    </SwitchWrapper>
  );
};

export default Switch;
